import { LocationData, LocationDataDTO, locationDataFromDTO } from '@/lib/types'

import { fetchAPI } from '.'

export async function getLocations(): Promise<LocationData[]> {
  const locations = await fetchAPI('GET', 'locations')

  return locations.map((location: LocationDataDTO) =>
    locationDataFromDTO(location)
  )
}
